import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import Button from '~/components/Button';
import LoginModal from '~/components/Layout/Nav/LoginModal';
import type { Publication } from '~/interfaces/publication';

interface Props {
  publication: Publication;
}

const MockCommentBox = ({ publication }: Props) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <LoginModal isOpen={isOpen} handleCloseModal={() => setIsOpen(false)} publication={publication} />
      <div className="relative">
        <div className="overflow-hidden rounded-wt border border-gray-300 shadow-sm focus-within:border-wt-primary focus-within:ring-1 focus-within:ring-wt-primary">
          <label htmlFor="comment" className="sr-only">
            {t('comments.commenting.comment_action_placeholder')}
          </label>
          <textarea
            rows={2}
            name="content"
            id="comment"
            className="block w-full resize-none border-0 bg-transparent py-3 text-sm focus:ring-0"
            placeholder={`${t('comments.commenting.comment_action_placeholder')}...`}
            required
          />

          <div className="py-2" aria-hidden="true">
            <div className="py-px">
              <div className="h-6" />
            </div>
          </div>
        </div>

        <div className="absolute inset-x-0 bottom-0 flex justify-between py-2 pl-3 pr-2">
          <div className="flex items-center space-x-5">
            <div className="flex-shrink-0" />
          </div>
          <div className="flex-shrink-0 pr-1">
            <Button btnSize="sm" type="button" onClick={() => setIsOpen(true)}>
              {t('shared.cta.login')}
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default MockCommentBox;
